import script from "./EventsAndActivityPanelCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsAndActivityPanelCard.vue?vue&type=script&lang=ts&setup=true"

import "./EventsAndActivityPanelCard.vue?vue&type=style&index=0&id=dbffb000&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbffb000"]])

export default __exports__